import { render, staticRenderFns } from "./Carousels.vue?vue&type=template&id=4e59ac4c&scoped=true"
import script from "./Carousels.vue?vue&type=script&lang=js"
export * from "./Carousels.vue?vue&type=script&lang=js"
import style0 from "./Carousels.vue?vue&type=style&index=0&id=4e59ac4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59ac4c",
  null
  
)

export default component.exports